import { UserService } from './../../../services/user.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { first } from 'rxjs/internal/operators/first';

@Component({
  selector: 'app-change-email',
  templateUrl: './change-email.component.html',
  styleUrls: ['./change-email.component.scss']
})
export class ChangeEmailComponent implements OnInit {

  user: any;
  email: string;
  
  constructor(private userService: UserService,
              private route: ActivatedRoute,
              private pageTitleService: Title) { }

  ngOnInit(): void {
    this.setPageTitle();
  }

  setPageTitle() {
    this.pageTitleService.setTitle(this.route.snapshot.data.title || 'Change Email');
  }

  getUserProfile() {
    this.userService.getProfile()
      .pipe(first())
      .subscribe(
        data => {
          this.user = data.user;
          this.email = this.user.email;
        }
      );
  }

}
